import React from "react";

export enum TooltipDirection {
  top = "top",
  bottom = "bottom",
  left = "left",
  right = "right",
}

export interface TooltipProps {
  show: boolean;
  close: Function;
  children: React.ReactNode;
  content: React.ReactNode;
  direction: TooltipDirection;
  offsetHorizontal?: number;
  offsetVertical?: number;
}
